import { Table } from 'semantic-ui-react';
import React from 'react';

export function PhoneInventoryTableHeader(props) {
  const tableHeader = props.header.map((head, index) => {
    if (head.sort !== '') {
      return (
        <Table.HeaderCell
          key={index}
          width={head.width}
          sorted={props.column === head.sort ? props.direction : null}
          onClick={() => props.handleSort(head.sort)}
          style={typeof head.checkbox !== 'undefined' ? { display: 'none' } : {}}
        >
          {typeof head.checkbox === 'undefined' ? head.title : null}
        </Table.HeaderCell>
      );
    } else {
      return (
        <Table.HeaderCell key={index} width={head.width} style={typeof head.checkbox !== 'undefined' ? { display: 'none' } : {}}>
          {typeof head.checkbox === 'undefined' ? (
            head.title
          ) : null}
        </Table.HeaderCell>
      );
    }
  });

  return (
    <Table.Header>
      <Table.Row>{tableHeader}</Table.Row>
    </Table.Header>
  );
}
